export default __webpack_public_path__ + "static/media/1d47d191b51c9563f83a9d045b8a6f63.2ecd900a.png";